// src/components/CaseStudyCard.jsx
import React from "react";
import { Typography, Card, CardContent, CardActionArea } from "@mui/material";

const CaseStudyCard = ({ title, link, image }) => {
  console.log("Image path:", image);
  return (
    <Card
      sx={{
        maxWidth: 345,
        m: 2,
        textAlign: "center",
        backgroundColor: "transparent",
        boxShadow: "none",
      }}
    >
      <CardActionArea>
        <img
          src={image}
          alt={title}
          style={{ width: "100%", height: "auto" }}
        />
      </CardActionArea>
      <CardContent sx={{ backgroundColor: "transparent", p: 0 }}>
        <a href={link} style={{ textDecoration: "none", color: "inherit" }}>
          <Typography
            variant="h6"
            component="div"
            sx={{
              mt: 2,
              fontFamily: "Golos Text",
              fontSize: "22px",
              fontWeight: 600,
              lineHeight: "32px",
              letterSpacing: "-0.0132em",
              textAlign: "center",
              textUnderlinePosition: "from-font",
              textDecorationSkipInk: "none",
              color: "#5F5E61",
            }}
          >
            {title}
          </Typography>
          <Typography
            style={{
              fontFamily: "Golos Text",
              fontWeight: 400,
              fontSize: "16px",
              textAlign: "center",
              marginTop: "15px",
            }}
          >
            Explore Case Studies ↗
          </Typography>
        </a>
      </CardContent>
    </Card>
  );
};

export default CaseStudyCard;
